import cn from 'classnames';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import ImageViewer from 'react-simple-image-viewer';
import PostingsWbApi from '../../../../../API/shipment/postingsWb-api';
import default_image from '../../../../../assets/media/icons/products.png';
import { Column, Row } from '../../../../../components/Basic/Blocks';
import { Button } from '../../../../../components/Basic/Buttons';
import { Input } from '../../../../../components/Basic/Inputs';
import { TableCell, TableLine } from '../../../../../components/Basic/Table';
import { TextGrey } from '../../../../../components/Basic/WrapsStyle';
import ProviderList from '../../../../../components/Common/Input/ProviderList';
import { TYPE_BUTTONS } from '../../../../../constans';
import { formFullDate, getDateMonth } from '../../../../../utils';
import { WIDTH_POSTING } from '../index';
import CancelWbExpresPosting from './CancelWbExpresPostingPopUp';
import styles from './styles.module.scss';
import CancelWbExpresPostingPopUp from './CancelWbExpresPostingPopUp';

const DELIVERY_TYPE = {
  cc: 'Самовывоз',
  edbs: 'Доставка',
};

const WbPostingExpressLine = ({
  shipmentMode = true,
  order = {},
  shipment = {},
  map = {},
  postingsPrint = {},
  tab,
  changePostingPrint = (_) => _,
  printSticker = (_) => _,
  changePrintStatus = (_) => _,
  ...props
}) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const [code, setCode] = useState('');
  const [openCancel, setOpenCancel] = useState(false);

  const [images, setImages] = useState([]);

  const dispatch = useDispatch();

  const openImageViewer = (images) => {
    setImages(images);
    setIsViewerOpen(true);
  };
  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages([]);
  };

  const scan_time_first = order.scan_time?.['pick'] ? formFullDate(order.scan_time?.['pick']) : null;
  const scan_time_order = order.scan_time?.packager ? formFullDate(order.scan_time?.packager) : null;

  return (
    <TableLine key={order.number}>
      <TableCell width={WIDTH_POSTING[0]}>
        {order.posting_number}
        {order.market === 'wb' && <span className={styles.wb_sticker}>{order.sticker_parts?.second}</span>} <br />
        <Row style={{ width: '100%' }}>
          {order.market === 'wb' && <TextGrey style={{ fontSize: '18px', color: '#6c11c9' }}>{order.shop}</TextGrey>}
          {order.market === 'yandex' && (
            <TextGrey style={{ fontSize: '18px', color: 'rgb(193 61 0)' }}>{order.shop}</TextGrey>
          )}
          {order.market === 'ozon' && (
            <TextGrey style={{ fontSize: '18px', color: 'rgb(19,79,231)' }}>{order.shop}</TextGrey>
          )}
          {order.market === 'megamarket' && (
            <TextGrey style={{ fontSize: '18px', color: 'rgb(13,131,25)' }}>{order.shop}</TextGrey>
          )}
        </Row>
      </TableCell>
      <TableCell width={WIDTH_POSTING[12]} center>
        <div
          className={cn(
            styles.delivery_type,
            order.express_info?.delivery_type === 'cc' && styles.cc,
            order.express_info?.delivery_type === 'edbs' && styles.edbs,
          )}
        >
          {getDateMonth(order.dates.created_at)}
          <div>{DELIVERY_TYPE[order.express_info?.delivery_type]}</div>
        </div>
      </TableCell>
      <TableCell width={WIDTH_POSTING[1]}>
        <Column>
          {order.products.map((p, k) => {
            const data = map[p.offer_id] || {};
            const img = data.images ? (data.images.length > 0 ? data.images : [default_image]) : [default_image];
            return (
              <div key={k} className={styles.div_line_images}>
                <div className={styles.wrapper}>
                  <img
                    onClick={() => openImageViewer(img)}
                    className={styles.preview}
                    src={img.length > 0 ? img[0] : undefined}
                  />
                </div>
                <Column>
                  <div className={styles.name}>
                    {`${p.ordered_quantity} x ${p.name}  `}
                    <div className={cn(styles.offer_id, p.status === 'Нет в наличии' && styles.red_text)}>
                      {p.offer_id}
                    </div>
                  </div>
                </Column>
              </div>
            );
          })}
        </Column>
      </TableCell>
      <TableCell width={WIDTH_POSTING[4]}>
        <Column style={{ alignItems: 'center' }}>
          {order.products.map((p, k) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={k} className={styles.div_line} style={{ marginBottom: '0px' }}>
              <ProviderList selectProviderId={p.provider_id} disabled={true} />
            </div>
          ))}
        </Column>
      </TableCell>
      <TableCell width={WIDTH_POSTING[4]} center={true}>
        <div
          className={cn(
            styles.status,
            order.status === 'Ожидает отгрузки' && styles.process,
            order.status === 'Не принят на CЦ' && styles.waiting,
            order.status === 'Идёт приёмка' && styles.waiting,
            order.status === 'Доставляется' && styles.sorted,
            order.status === 'Прибыл на ПВЗ' && styles.pickup,
            order.status === 'Продано' && styles.sold,
            order.status === 'Доставлено' && styles.sold,
            order.status === 'Отменено' && styles.canceled,
            order.status === 'Отменено клиентом' && styles.controversial,
            order.status === 'Арбитраж' && styles.controversial,
            order.status === 'Обнаружен брак' && styles.waiting,
            order.cancellation?.is_return && styles.return,
          )}
        >
          {order.cancellation?.is_return ? 'Возврат' : order.status}
        </div>
      </TableCell>

      <TableCell width={WIDTH_POSTING[4]} center>
        <div>{order.express_info?.planned_date}</div>
      </TableCell>

      {tab == 1 && (
        <TableCell>
          <Row>
            <Button
              type={TYPE_BUTTONS.GREEN}
              style={{ marginBottom: '5px', marginRight: '10px' }}
              onClick={() => PostingsWbApi.deliveryOrder({ data: { shop: 'wb1', ordersIds: [order.order_number] } })}
            >
              Передать в доставку
            </Button>
            <Button
              type={TYPE_BUTTONS.RED}
              style={{ marginBottom: '5px' }}
              onClick={() => PostingsWbApi.cancelOrder({ data: { shop: 'wb1', ordersIds: [order.order_number] } })}
            >
              Отменить заказ
            </Button>
          </Row>
        </TableCell>
      )}

      {tab == 2 && (
        <TableCell>
          <Row>
            <Input
              value={code}
              onChange={(v) => setCode(v)}
              placeholder="Код"
              width={'60px'}
              disabled={order.express_info?.delivery_type === 'cc'}
              style={{ marginRight: '15px' }}
            />
            <Button
              type={TYPE_BUTTONS.GREEN}
              disabled={order.express_info?.delivery_type === 'cc' || code.length < 5}
              style={{ marginBottom: '5px', marginRight: '10px' }}
              onClick={() => PostingsWbApi.receiveOrder({ data: { shop: 'wb1', ordersIds: [order.order_number], code } })}
            >
              Подвердить доставку
            </Button>
            <Button
              type={TYPE_BUTTONS.RED}
              disabled={order.express_info?.delivery_type === 'cc' || code.length < 5}
              style={{ marginBottom: '5px' }}
              onClick={() => setOpenCancel(true)}
            >
              Отменить доставку
            </Button>
          </Row>
        </TableCell>
      )}

      <TableCell>
        <div>
          <Row>
            <TextGrey>Адрес: </TextGrey>
            {order.express_info?.address}
          </Row>
          <Row>
            <TextGrey>Покупатель: </TextGrey>
            {order.express_info?.name} {order.express_info?.phone}
          </Row>
          <Row>
            <TextGrey>Комментарий: </TextGrey>
            {order.express_info?.comment}
          </Row>
        </div>
      </TableCell>
      {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
      {openCancel && (
        <CancelWbExpresPostingPopUp
          close={() => setOpenCancel(false)}
          clickOk={() => PostingsWbApi.rejectOrder({ data: { shop: 'wb1', ordersIds: [order.order_number], code } })}
        />
      )}
    </TableLine>
  );
};

export default WbPostingExpressLine;
